/**
 * Categories ordered by ranking
 */
export const LOG_CATEGORIES = ['error', 'warn', 'info', 'debug', 'log'];
/**
 * Compares the two categories and returns true if the first one ranks lower than the second one
 * @param category
 * @param compareToCategory
 */
export function compareLogCategories(category, compareToCategory) {
    return LOG_CATEGORIES.indexOf(category) <= LOG_CATEGORIES.indexOf(compareToCategory);
}
//# sourceMappingURL=log-category.js.map